import { gql } from '@apollo/client'

export const GET_COMPANY_VOE_OUTREACH_CONFIG = gql`
  query GetCompanyVoEOutreachConfig($companyId: String!) {
    companyVoEOutreachConfig(companyId: $companyId) {
      outreachConfigId
      companyId
      enabled
      businessDaysOnly
      outreachTrigger
      requiredManualAttempts
      skipCurrentEmployer
      steps {
        outreachStepId
        order
        type
        delayHours
      }
    }
  }
`

export const UPSERT_COMPANY_VOE_OUTREACH_CONFIG = gql`
  mutation UpsertCompanyVoEOutreachConfig(
    $companyId: String!
    $input: UpsertCompanyVoEOutreachConfigInput!
  ) {
    upsertCompanyVoEOutreachConfig(companyId: $companyId, input: $input) {
      outreachConfigId
      companyId
      enabled
      businessDaysOnly
      outreachTrigger
      requiredManualAttempts
      skipCurrentEmployer
      steps {
        outreachStepId
        order
        type
        delayHours
      }
    }
  }
`

const VOE_CALL_SCHEDULING_FIELDS = `
  outreachConfigId
  companyId
  callSchedulingEnabled
  callWindowStartMinute
  callWindowEndMinute
  callRetryIntervalMinutes
  callMaxAttempts
`

export const GET_VOE_CALL_SCHEDULING = gql`
  query GetVoECallScheduling($companyId: String!) {
    companyVoEOutreachConfig(companyId: $companyId) {
      ${VOE_CALL_SCHEDULING_FIELDS}
    }
  }
`

export const UPDATE_VOE_CALL_SCHEDULING = gql`
  mutation UpdateVoECallScheduling(
    $companyId: String!
    $input: UpdateVoECallSchedulingInput!
  ) {
    updateVoECallScheduling(companyId: $companyId, input: $input) {
      ${VOE_CALL_SCHEDULING_FIELDS}
    }
  }
`

export const BACKFILL_VOE_OUTREACH = gql`
  mutation BackfillVoEOutreach($input: BackfillVoEOutreachInput!) {
    backfillVoEOutreach(input: $input) {
      queued
    }
  }
`
